import { Redirect, useLocation } from 'react-router-dom';
import React from 'react';

export const RedirectWithQuery = ({ to }) => {
  const { search } = useLocation();
  const newTo = `${to}${search}`;
  return <Redirect to={newTo} />;
};
